/* Shared aurora background for dark (#1d1d1f) story banners — grayscale, faint, blobs anchored left/right of the centered headline */
function mlbInitAurora(canvasId, sectionId) {
  var canvas = document.getElementById(canvasId);
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var palette = [
    ['hsla(0, 0%, 92%, 0.16)', 'hsla(0, 0%, 60%, 0.09)', 'transparent'],
    ['hsla(0, 0%, 100%, 0.12)', 'transparent', 'transparent']
  ];
  var blobCount = 5;
  var speed = 1.4;
  var t = 0;
  var raf = null;

  function resize() {
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }

  function drawFrame() {
    var w = canvas.width, h = canvas.height;
    ctx.clearRect(0, 0, w, h);

    for (var i = 0; i < blobCount; i++) {
      var layer = palette[i % palette.length];
      var side = (i % 2 === 0) ? -1 : 1;
      var baseX = w / 2 + side * w * 0.34;
      var phase = (i / blobCount) * Math.PI * 2 + t;
      var x = baseX + Math.sin(phase) * (w * 0.08) + Math.cos(t * 0.5) * (w * 0.04);
      var y = h / 2 + Math.cos(phase * 0.7) * (h * 0.28) + Math.sin(t * 0.3) * (h * 0.12);
      var gradient = ctx.createRadialGradient(x, y, 0, x, y, Math.max(w, h) * 0.3);
      gradient.addColorStop(0, layer[0]);
      gradient.addColorStop(0.5, layer[1]);
      gradient.addColorStop(1, layer[2]);
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, w, h);
    }

    ctx.globalCompositeOperation = 'screen';
    for (var j = 0; j < Math.min(2, palette.length); j++) {
      var layer2 = palette[j];
      var side2 = (j === 0) ? -1 : 1;
      var baseX2 = w / 2 + side2 * w * 0.3;
      var phase2 = (j / 2) * Math.PI + t * 0.8;
      var x2 = baseX2 + Math.sin(phase2 * 1.2) * (w * 0.06);
      var y2 = h / 2 + Math.cos(phase2 * 0.9) * (h * 0.2);
      var gradient2 = ctx.createRadialGradient(x2, y2, 0, x2, y2, Math.max(w, h) * 0.26);
      gradient2.addColorStop(0, layer2[0]);
      gradient2.addColorStop(1, 'transparent');
      ctx.fillStyle = gradient2;
      ctx.fillRect(0, 0, w, h);
    }
    ctx.globalCompositeOperation = 'source-over';
  }

  resize();
  window.addEventListener('resize', resize);

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    drawFrame();
  } else {
    (function animate() {
      t += 0.01 * speed;
      drawFrame();
      raf = requestAnimationFrame(animate);
    })();
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail && e.detail.sectionId === sectionId) {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    }
  });
}
